import { cn, tv } from "@utils/tw"
import { createAppender, defineBlock, EditableText, InnerBlocks, useInnerBlocks } from "eddev/blocks"

export const meta: BlockMeta = {
  title: "TFF Centre Sponsors",
}

export default defineBlock("tff-center/tff-center-sponsors", (props) => {
  const hasLogos = !!useInnerBlocks().find((item) => item.slug === "content/logo-item" && !!item.props.logo)

  if (!env.admin && !hasLogos) return null

  return (
    <div className="my-8">
      <div className="grid-auto">
        <div className="col-span-12 border-t border-bg-mid pt-6 pb-4 flex items-start">
          <EditableText
            as="h3"
            store="heading"
            defaultValue={`TFF ${props.tffCenter?.title} sponsors`}
            className="type-label-caps"
          />
        </div>
        <div className={cn("col-span-12 pb-6", !env.admin && layout({}))}>
          <InnerBlocks
            orientation="horizontal"
            defaultBlocks={[["content/logo-item", {}]]}
            allowedBlocks={["content/logo-item"]}
            adminClassName={cn(layout({}), "[&_.block-list-appender]:relative")}
            appender={{ type: "button" }}
          />
        </div>
      </div>
    </div>
  )
})

const layout = tv({
  base: "grid w-full items-center gap-5 [&_.admin-message-box]:w-full [&_.admin-message-box]:h-full [&_.admin-message-box]:absolute [&_.admin-message-box]:top-0 [&_.admin-message-box]:left-0 [&_.admin-message-box]:flex [&_.admin-message-box]:items-center [&_.admin-message-box]:justify-center",
  variants: {
    size: {
      sm: "grid-cols-4 md:grid-cols-7 lg:grid-cols-8",
      md: "grid-cols-3 md:grid-cols-6 lg:grid-cols-7",
      lg: "grid-cols-2 md:grid-cols-5 lg:grid-cols-6",
    },
  },
  defaultVariants: {
    size: "sm",
  },
})
